<template>
  <div class="wrapper">
    <div class="iq-sidebar sidebar-default">
      <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
        <router-link :to="dashboardRoute" class="header-logo">
          <h5 class="logo-title light-logo ml-3">Dalto Investments</h5>
        </router-link>
        <div class="iq-menu-bt-sidebar ml-0">
          <i class="las la-bars wrapper-menu"></i>
        </div>
      </div>
      <div class="data-scrollbar" data-scroll="1">
        <nav class="iq-sidebar-menu">
          <ul id="iq-sidebar-toggle" class="iq-menu">
            <li class="active">
              <router-link v-if="isAdmin" to="/dashboard" class="svg-icon">
                <svg class="svg-icon" id="p-dash1" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <span class="ml-4">Quick Access</span>
              </router-link>
              <router-link v-if="!isAdmin" to="/" class="svg-icon">
                <svg class="svg-icon" id="p-dash1" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <span class="ml-4">Quick Access</span>
              </router-link>
            </li>
            <li>
              <router-link v-if="isAdmin" to="/wallet-deposit-admin">
                <svg class="svg-icon" id="p-dash3" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <span class="ml-4">Deposits</span>
              </router-link>
              <router-link v-if="!isAdmin" to="/wallet-deposit">
                <svg class="svg-icon" id="p-dash3" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <span class="ml-4">Deposits</span>
              </router-link>
            </li>
            <li>
              <a href="#otherpage" class="collapsed" data-toggle="collapse" aria-expanded="false">
                <svg class="svg-icon" id="p-dash9" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <rect x="7" y="7" width="3" height="9"></rect>
                  <rect x="14" y="7" width="3" height="5"></rect>
                </svg>
                <span class="ml-4">Accounts</span>
                <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="10 15 15 20 20 15"></polyline>
                  <path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                </svg>
              </a>
              <ul id="otherpage" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle">
                <li>
                  <a href="#user" class="collapsed" data-toggle="collapse" aria-expanded="false">
                    <svg class="svg-icon" id="p-dash10" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="8.5" cy="7" r="4"></circle>
                      <polyline points="17 11 19 13 23 9"></polyline>
                    </svg>
                    <span class="ml-4">My Transactions</span>
                    <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="10 15 15 20 20 15"></polyline>
                      <path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                    </svg>
                  </a>
                  <ul id="user" class="iq-submenu collapse" data-parent="#otherpage">
                    <li v-if="isAdmin">
                      <router-link to="/network-address">
                        <i class="las la-minus"></i><span>Network & Wallet Address</span>
                      </router-link>
                    </li>
                    <li v-if="isAdmin">
                      <router-link to="/investment-interest">
                        <i class="las la-minus"></i><span>Interest Rate</span>
                      </router-link>
                    </li>
                    <li v-if="!isAdmin">
                      <router-link to="/my-referral-users">
                        <i class="las la-minus"></i><span>My Referrall Users</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/return-on-investment">
                        <i class="las la-minus"></i><span>Investment Profit</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/withdraw-transctions">
                        <i class="las la-minus"></i><span>Withdraw Transactions</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link v-if="!isAdmin" to="/deposit-transactions">
                        <i class="las la-minus"></i><span>Deposits Transactions</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/user-profile">
                        <i class="las la-minus"></i><span>My Profile</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link v-if="isAdmin" to="/create-notification">
                        <i class="las la-minus"></i><span>Create Notification</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div id="sidebar-bottom" class="position-relative sidebar-bottom">
          <div class="card border-none">
            <div class="card-body p-0">
              <div class="sidebarbottom-content">
                <div class="image">
                  <img src="assets/images/logo-dalto.jpeg" class="img-fluid" alt="side-bkg" />
                </div>
                <h6 class="mt-4 px-4 body-title">
                  Get Rewarded for Referring Friends
                </h6>
                <button type="button" class="btn sidebar-bottom-btn mt-4" data-toggle="modal" data-target="#new-order">
                  Refer To Friends
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3"></div>
      </div>
    </div>
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <div class="iq-navbar-logo d-flex align-items-center justify-content-between">
            <i class="ri-menu-line wrapper-menu"></i>
            <router-link :to="dashboardRoute" class="header-logo">
              <img src="assets/images/logo.png" class="img-fluid rounded-normal" alt="logo" />
              <h5 class="logo-title ml-3">Dalto Investments</h5>
            </router-link>
          </div>
          <div class="iq-search-bar device-search">
            <form action="#" class="searchbox">
              <a class="search-link" href="#"><i class="ri-search-line"></i></a>
              <input type="text" class="text search-input" placeholder="Search here..." />
            </form>
          </div>
          <div class="d-flex align-items-center">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-label="Toggle navigation">
              <i class="ri-menu-3-line"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto navbar-list align-items-center">
                <li class="nav-item nav-icon dropdown">
                  <a href="#" class="search-toggle dropdown-toggle btn border add-btn" id="dropdownMenuButton02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img src="assets/images/small/flag-01.png" alt="img-flag" class="img-fluid image-flag mr-2" />En
                  </a>
                  <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <div class="card shadow-none m-0">
                      <div class="card-body p-3">
                        <a class="iq-sub-card" href="#"><img src="assets/images/small/flag-02.png" alt="img-flag" class="img-fluid mr-2" />French</a>
                        <a class="iq-sub-card" href="#"><img src="assets/images/small/flag-03.png" alt="img-flag" class="img-fluid mr-2" />Spanish</a>
                        <a class="iq-sub-card" href="#"><img src="assets/images/small/flag-04.png" alt="img-flag" class="img-fluid mr-2" />Italian</a>
                        <a class="iq-sub-card" href="#"><img src="assets/images/small/flag-05.png" alt="img-flag" class="img-fluid mr-2" />German</a>
                        <a class="iq-sub-card" href="#"><img src="assets/images/small/flag-06.png" alt="img-flag" class="img-fluid mr-2" />Japanese</a>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="#" class="btn border add-btn shadow-none mx-2 d-none d-md-block" data-toggle="modal" data-target="#new-order">
                    <i class="las la-plus mr-2"></i>Referral Promo Code
                  </a>
                </li>
                <li class="nav-item nav-icon search-content">
                  <a href="#" class="search-toggle rounded" id="dropdownSearch" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="ri-search-line"></i>
                  </a>
                  <div class="iq-search-bar iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownSearch">
                    <form action="#" class="searchbox p-2">
                      <div class="form-group mb-0 position-relative">
                        <input type="text" class="text search-input font-size-12" placeholder="type here to search..." />
                        <a href="#" class="search-link"><i class="las la-search"></i></a>
                      </div>
                    </form>
                  </div>
                </li>
                <li class="nav-item nav-icon dropdown">
                  <a href="#" class="search-toggle dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bell">
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                    <span v-if="unreadCount > 0" class="bg-primary count-mail">{{ unreadCount }}</span>
                  </a>
                  <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0">
                        <div class="cust-title p-3">
                          <div class="d-flex align-items-center justify-content-between">
                            <h5 class="mb-0">Notifications</h5>
                            <span v-if="unreadCount > 0" class="badge badge-primary badge-card">
                              {{ unreadCount }}
                            </span>
                          </div>
                        </div>
                        <div v-if="loadingNotifications" class="text-center p-3">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <div v-else-if="recentNotifications.length === 0" class="text-center p-3">
                          <small>No notifications available</small>
                        </div>
                        <div v-else class="px-3 pt-0 pb-0 sub-card">
                          <router-link
                            v-for="notification in recentNotifications"
                            :key="notification.id"
                            :to="{ name: 'SingleNotification', params: { id: notification.id } }"
                            class="iq-sub-card"
                          >
                            <div class="media align-items-center cust-card py-3 border-bottom">
                              <div>
                                <img
                                  class="avatar-50 rounded-small"
                                  :src="notification.sender?.avatar || 'assets/images/user/01.jpg'"
                                  alt="sender"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div class="d-flex align-items-center justify-content-between">
                                  <h6 class="mb-0">{{ notification.title }}</h6>
                                  <small class="text-dark">
                                    <b>{{ new Date(notification.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) }}</b>
                                  </small>
                                </div>
                                <small class="mb-0">{{ truncateMessage(notification.message, 30) }}</small>
                              </div>
                            </div>
                          </router-link>
                        </div>
                        <router-link class="right-ic btn btn-primary btn-block position-relative p-2" to="/notifications" role="button">
                          View All
                        </router-link>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="nav-item nav-icon dropdown caption-content">
                  <a href="#" class="search-toggle dropdown-toggle" id="dropdownMenuButton4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img src="assets/images/user/1.png" class="img-fluid rounded" alt="user" />
                  </a>
                  <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0 text-center">
                        <div class="media-body profile-detail text-center">
                          <img src="assets/images/logo-dalto.jpeg" alt="profile-bg" class="rounded-top img-fluid mb-4" />
                          <img src="assets/images/user/1.png" alt="profile-img" class="rounded profile-img img-fluid avatar-70" />
                        </div>
                        <div class="p-3">
                          <h5 class="mb-1">
                            {{ userData?.email || "-" }}
                          </h5>
                          <p class="mb-0">
                            Since
                            {{
                              userData?.created_at
                                ? new Date(userData.created_at).toLocaleDateString()
                                : "N/A"
                            }}
                          </p>
                          <div class="d-flex align-items-center justify-content-center mt-3">
                            <router-link to="/user-profile" class="btn border mr-2">Profile</router-link>
                            <button @click="handleLogout" class="btn border" :disabled="loggingOut">
                              {{ loggingOut ? "Signing Out..." : "Sign Out" }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <div class="modal fade" id="new-order" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="popup text-left">
              <h4 class="mb-3">
                Copy Your Promo Code and Share to Your Friends to Get Rewarded
              </h4>
              <div class="content create-workform bg-body">
                <div class="pb-3">
                  <label class="mb-2">Your Referral Promo Code</label>
                  <div class="input-group">
                    <input
                      type="text"
                      :value="referralPromoCode"
                      class="form-control"
                      placeholder="Your Promo Code"
                      readonly
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-primary"
                        @click="copyPromoCode"
                        :disabled="isCopying"
                      >
                        <i class="ri-file-copy-line"></i>
                        {{ isCopying ? 'Copying...' : 'Copy' }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mt-4">
                  <div class="d-flex flex-wrap align-items-center justify-content-center">
                    <!-- Add share buttons here if needed -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view name="global"></router-view>
  </div>
  <footer class="iq-footer">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  <a href="#">Privacy Policy</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">Terms of Use</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-6 text-right">
              <span class="mr-1"> © </span>
              <a href="#" class="">Dalto Investments</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import apiClient from '../api/axios'

export default defineComponent({
  setup () {
    const router = useRouter()

    // State
    const userData = ref<any>(null)
    const loading = ref(true)
    const error = ref<string | null>(null)
    const loggingOut = ref(false)
    const isCopying = ref(false) // New state for copy button
    const totalCompletedDeposits = ref('0.00')

    // Notification state
    const loadingNotifications = ref(true)
    const recentNotifications = ref<any[]>([])
    const unreadCount = ref(0)
    const userId = ref<number | null>(null)
    let pollingInterval: number | null = null

    // Computed properties
    const isAdmin = computed(() => {
      return userData.value?.role === 'admin'
    })

    const dashboardRoute = computed(() => {
      if (!userData.value) return '/dashboard'
      return userData.value.role === 'user_client' ? '/' : '/dashboard'
    })

    const walletRoute = computed(() => {
      if (!userData.value) return '/wallet-deposit'
      return userData.value.role === 'user_client' ? '/wallet-deposit' : '/wallet-deposit-admin'
    })

    const referralPromoCode = computed(() => {
      return userData.value?.promocode || 'N/A'
    })

    // Fetch user data from localStorage with error handling
    const fetchUserData = () => {
      try {
        const userJson = localStorage.getItem('user')
        if (!userJson) {
          throw new Error('User data not found in localStorage.')
        }
        userData.value = JSON.parse(userJson)
        userId.value = userData.value?.id || null
      } catch (err) {
        console.error('Failed to parse user data from localStorage:', err)
        error.value = 'User data not found. Please sign in to continue.'
        userData.value = null
        userId.value = null
      }
    }

    // Fetch total completed deposits
    const fetchTotalCompletedDeposits = async () => {
      try {
        const response = await apiClient.get('/total-completed-deposits')
        totalCompletedDeposits.value = response.data.data.total_completed_deposits
      } catch (err: any) {
        if (err.response?.status === 401) {
          error.value = 'Your session has expired. Please sign in again.'
          localStorage.removeItem('auth_token')
          localStorage.removeItem('user')
          router.push('/auth-sign-in')
        } else {
          console.error('Failed to fetch total completed deposits:', err.response?.data)
        }
      }
    }

    // Fetch recent notifications
    const fetchRecentNotifications = async () => {
      loadingNotifications.value = true
      try {
        const response = await apiClient.get('/notifications', {
          params: { per_page: 3 }
        })
        recentNotifications.value = response.data.data
      } catch (err: any) {
        console.error('Failed to fetch notifications:', err.response?.data)
      } finally {
        loadingNotifications.value = false
      }
    }

    // Fetch unread notification count
    const fetchUnreadCount = async () => {
      if (!userId.value) {
        console.error('User ID not available')
        return
      }
      try {
        const response = await apiClient.get('/notifications/unread-count', {
          params: { user_id: userId.value }
        })
        unreadCount.value = response.data.data.unread_count
      } catch (err: any) {
        console.error('Error fetching unread count:', err.response?.data || err)
      }
    }

    // Fetch notifications
    const fetchNotifications = async () => {
      if (!userId.value) {
        console.error('User ID not available')
        return
      }
      try {
        const response = await apiClient.get('/notifications', {
          params: { user_id: userId.value, per_page: 5 }
        })
        recentNotifications.value = response.data.data
      } catch (err: any) {
        console.error('Error fetching notifications:', err.response?.data || err)
      }
    }

    // Poll notifications
    const pollNotifications = async () => {
      await Promise.all([fetchNotifications(), fetchUnreadCount()])
      loadingNotifications.value = false
    }

    // Truncate message for display
    const truncateMessage = (message: string, length: number) => {
      if (message.length <= length) return message
      return message.substring(0, length) + '...'
    }

    // Handle logout
    const handleLogout = async () => {
      loggingOut.value = true
      try {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
        router.push('/auth-sign-in')
      } catch (err) {
        console.error('Logout failed:', err)
      } finally {
        loggingOut.value = false
      }
    }

    // Copy promo code to clipboard
    const copyPromoCode = async () => {
      isCopying.value = true
      try {
        await navigator.clipboard.writeText(referralPromoCode.value)
        alert('Promo code copied to clipboard!')
      } catch (err) {
        console.error('Failed to copy promo code:', err)
        alert('Failed to copy promo code. Please try again.')
      } finally {
        isCopying.value = false
      }
    }

    // Lifecycle hooks
    onMounted(async () => {
      try {
        // Fetch user data from localStorage
        fetchUserData()

        const token = localStorage.getItem('auth_token')
        if (!userData.value || !token) {
          error.value = 'User data or token not found. Please sign in to continue.'
          router.push('/auth-sign-in')
          return
        }

        apiClient.defaults.headers.common.Authorization = `Bearer ${token}`

        // Fetch data
        await Promise.all([
          fetchTotalCompletedDeposits(),
          fetchRecentNotifications(),
          fetchUnreadCount()
        ])

        // Start polling notifications
        await pollNotifications()
        pollingInterval = setInterval(pollNotifications, 30000)
      } catch (err) {
        console.error('Error during mounted:', err)
        error.value = 'Failed to load data. Please sign in again.'
        router.push('/auth-sign-in')
      } finally {
        loading.value = false
      }
    })

    onUnmounted(() => {
      if (pollingInterval) {
        clearInterval(pollingInterval)
      }
    })

    return {
      userData,
      loading,
      error,
      loggingOut,
      isCopying,
      isAdmin,
      totalCompletedDeposits,
      dashboardRoute,
      walletRoute,
      referralPromoCode,
      recentNotifications,
      unreadCount,
      loadingNotifications,
      truncateMessage,
      handleLogout,
      copyPromoCode
    }
  }
})
</script>

<style scoped>
.count-mail {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.badge-card {
  padding: 5px 10px;
  font-size: 12px;
}

.iq-sub-card:hover {
  background-color: #f8f9fa;
}

.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
